import { ComponentPropsWithoutRef } from "react";
import { Heading } from "~/components/elements/Heading";
import { Image } from "~/components/elements/Image";
import Grid from "~/components/globals/Grid";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import * as styles from "./SectionBlockMediaContent.css";
import { Content, Socials as ISocials } from "~/sanity/types";
import { ILinkProps } from "~/components/elements/Link";
import { ButtonLink } from "~/components/elements/ButtonLink";
// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { Tag, TagProps } from "~/components/elements/Tag";
import { Paragraph } from "~/components/elements/Paragraph";
import { Socials } from "~/components/elements/Socials";

export type SectionBlockMediaContentProps = ComponentPropsWithoutRef<"div"> & {
  data: {
    title?: string;
    subheading?: string;
    image: any;
    text?: Content;
    link?: ILinkProps;
    tags?: TagProps[];
    socials?: ISocials;
  };
};

export const SectionBlockMediaContent = ({
  data,
  ...props
}: SectionBlockMediaContentProps) => {
  const { title, image, text, link, tags, subheading, socials } = data;
  return (
    <section className={styles.container}>
      <Grid>
        <div className={styles.imageContainer}>
          <Image
            image={image}
            width={1920}
            loading="eager"
            className={styles.image}
          />
        </div>
        <div className={styles.content}>
          {tags && (
            <div className={styles.tags}>
              {tags.map((tag, index) => (
                <Tag key={index} {...tag} size="sm" />
              ))}
            </div>
          )}

          <Heading as="h2" size="h2" uppercase bold>
            {title}
          </Heading>
          {subheading && <Paragraph size="mdXl">{subheading}</Paragraph>}
          {text && <PortableText blocks={text as IPortableText} />}
          {link && link.slug && (
            <div className={styles.button}>
              <ButtonLink
                link={link}
                theme="dark"
                isPrimary={true}
                icons={{ iconPrimary: <ArrowOutward /> }}
              >
                {link.text}
              </ButtonLink>
            </div>
          )}
          {socials && <Socials {...socials} />}
        </div>
      </Grid>
    </section>
  );
};
